import { httpTools } from "@lib/redux/http-utils";
import { apiSlice } from "@features/application/api-slice";
import { createBulkReadMutation } from "@features/feed/bulk-read";
import { eventsTools } from "@features/events/events-tools";
import { EventEntity, EventInputView, EventOutputView } from "@features/events/types/event";
import routes from "@features/routes";

const convertToDomainEntity = (data?: EventOutputView) =>
  data ? eventsTools.convertToDomainEntity(data) : undefined;

export const eventsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWorkspaceEvents: httpTools.getMultipleResponse<EventOutputView, EventEntity>(
      builder,
      routes.events.api.workspace_events,
      "Event",
      (data) => data?.map(eventsTools.convertToDomainEntity).sort(eventsTools.sortEventsByDateDesc),
    ),
    getEvent: httpTools.getOnceResponse<EventOutputView, EventEntity>(
      builder,
      routes.events.api.event,
      "Event",
      convertToDomainEntity,
    ),
    getProposalActivityEvent: httpTools.getOnceResponse<EventOutputView, EventEntity>(
      builder,
      routes.events.api.event,
      "Event",
      convertToDomainEntity,
      undefined,
      undefined,
      { suppressErrorNotificationStatuses: [403] },
    ),
    patchEvent: httpTools.patchOnceResponse<EventOutputView, EventEntity, EventInputView>(
      builder,
      routes.events.api.event,
      "Event",
      convertToDomainEntity,
    ),
    postEvent: httpTools.postOnceResponse<EventOutputView, EventEntity, EventInputView>(
      builder,
      routes.projects.api.project_events,
      "Event",
      convertToDomainEntity,
    ),
    archiveEvent: httpTools.postOnceResponse<EventOutputView, EventEntity, never>(
      builder,
      routes.events.api.event_archive,
      "Event",
      convertToDomainEntity,
      "once",
    ),
    bulkReadEvents: createBulkReadMutation<EventOutputView>(
      builder,
      routes.events.api.events_bulk_read,
    ),
  }),
  overrideExisting: false,
});

export const {
  useGetWorkspaceEventsQuery,
  useGetEventQuery,
  useGetProposalActivityEventQuery,
  usePatchEventMutation,
  usePostEventMutation,
  useArchiveEventMutation,
  useBulkReadEventsMutation,
} = eventsApi;
